import axios from '@/plugins/Axios'

function Requests () {
  async function fetchFreelancerCategories () {
    try {
      const { data } = await axios.get(`${process.env.VUE_APP_FREELANCER_API_BASE_URL}/category-list`)
      return data
    } catch (error) {
      console.log(error)
    }
  }

  async function fetchSourcingRequestSummary (formData) {
    try {
      // const { data } = await axios.post('/sourcing-request/summary', formData)
      return formData
    } catch (error) {
      console.log(error)
    }
  }

  async function createNewSourcingRequest (formData) {
    const { data } = await axios.post('/sourcing/sourcing-request/new', formData)
    return data
  }
  
  async function updateProductInformation (formData, sourcingRequestToken) {
    try {
      const { data } = await axios.post(`/sourcing/sourcing-request/${sourcingRequestToken}/product`, formData)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function addProductImage (formData, sourcingRequestToken) {
    try {
      const { data } = await axios.post(`/sourcing/sourcing-request/${sourcingRequestToken}/add-product-image`, formData)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function updateSupplierInformation (formData, sourcingRequestToken) {
    try {
      const { data } = await axios.post(`/sourcing/sourcing-request/${sourcingRequestToken}/supplier`, formData)
      return data
    } catch (error) {
      console.log(error)
    }
  }
  
  async function linkClientToSourcingRequest (formData, sourcingRequestToken) {
    try {
      const { data } = await axios.post(`/sourcing/sourcing-request/${sourcingRequestToken}/link-buyer`, formData)
      return data
    } catch (error) {
      console.log(error)
    }
  }

  async function removeProductImage (sourcingRequestToken, imageToken) {
    try {
      const { data } = await axios.delete(`/sourcing/sourcing-request/${sourcingRequestToken}/remove-product-image/${imageToken}`)
      return data
    } catch (error) {
      console.log(error)
    }
  }
  
  async function updateClientInformation (formData, sourcingRequestToken) {
    try {
      const { data } = await axios.post(`/sourcing/sourcing-request/${sourcingRequestToken}/client`, formData)
      return data
    } catch (error) {
      console.log(error)
    }
  }

  async function linkPaymentAndAddressRequest(payload, sourcingRequestToken) {
    try {
      const { data } = await axios.post(
        `/sourcing/sourcing-request/${sourcingRequestToken}/prepare-order`,
        payload
      );
      return data;
    } catch (error) {
      console.log(error);
    }
  }

  async function completePlaceOrderRequest(link) {
    try {
      const { data } = await axios.post(link);
      return data;
    } catch (error) {
      return error.response.data
    }
  }

  async function getSourcingOrderDraftInformation (sourcingRequestToken) {
    try {
      const { data } = await axios.get(`/sourcing/sourcing-request/${sourcingRequestToken}`)
      return data
    } catch (error) {
      console.log(error)
    }
  }

  return {
    fetchFreelancerCategories,
    fetchSourcingRequestSummary,
    createNewSourcingRequest,
    updateProductInformation,
    addProductImage,
    updateSupplierInformation,
    linkClientToSourcingRequest,
    removeProductImage,
    updateClientInformation,
    completePlaceOrderRequest,
    linkPaymentAndAddressRequest,
    getSourcingOrderDraftInformation
  }
}

export default Requests()